import {TenantFeedbackTypes} from "./tenant-feedback-types";

export class TenantMonthlyFeedbackPost {
    score: number;
    type: TenantFeedbackTypes;
}
